import moment from "moment/moment";

export const dbToDate = (date) => {
  return moment(date).format("DD-MMMM-YYYY");
};

export const dbToTime = (date) => {
  return moment(date).format("HH:mm");
};

export const dateToField = (date) => {
  if (date === "") return;

  return date.split("T")[0];
};

export const timeToField = (date) => {
  if (date === "") return;

  let time = date.split("T")[1];
  time = time.slice(0, 5);

  return time;
};

export const getDateTimeNow = () => {
  let date = new Date().toISOString().toString().split("T")[0];

  let hours = new Date().getHours();
  if (hours < 10) {
    hours = "0" + hours;
  }

  let minute = new Date().getMinutes();
  if (minute < 10) {
    minute = "0" + minute;
  }

  return date + "T" + hours + ":" + minute;
};

export const momentDateToDB = (dateTime) => {
  return moment(dateTime).format("YYYY-MM-DD");
};

export const momentTimeToDB = (dateTime) => {
  return moment(dateTime).format("HH:mm");
};
